ajuda.component('ajuda.ajudaComponent', {
    templateUrl: 'ajuda/ajuda.html',
    controller: 'ajuda.ajudaController',
    controllerAs: '$ctrl'
});

ajuda.controller('ajuda.ajudaController', ['$rootScope', '$scope', '$state', 'coreFb', function($rootScope, $scope, $state, $fb){
    const $ctrl = this;

    const BASE_URL="https://sup.fabricaoffice.com";

    const _getUsuario=(idUsuario)=>{
        $fb.db.get(`cad_usuarios/${idUsuario}`).then((doc)=>{
            $ctrl.usuario = doc;

            _addWidget();
        });
    };

    const _getAreaMembros=(idArea)=>{

        $fb.db.get(`cad_areaMembros/${idArea}`).then(doc=>{
            $ctrl.ajuda = doc.data.ajuda;

        }).catch(e=>{
            console.log(e);
        });
    };

    const _initChatwoot=()=>{
        window.chatwootSDK.run({
            websiteToken: 's5EPoZHiJTPTwHiXoLMSV1vy',
            baseUrl: BASE_URL
        });

        $scope.$apply(()=>{ $state.params.showGlobalLoading = false; });

        window.$chatwoot.setUser($ctrl.usuario.id, {
            name: $ctrl.usuario.data.nome,
            email: $ctrl.usuario.data.email,
            avatar_url: $ctrl.usuario.data.fotoUrl || null,
            identifier_has: "MPCXCB8XNzvpBHbCcb6DyuxF"
        });

        window.$chatwoot.toggle("open");
    }

    const _addWidget=()=>{
        window.chatwootSettings = {
            position:"center",
            type:"standard",
            launcherTitle:"Fale conosco no chat",
            hideMessageBubble: true,
            showUnreadMessagesDialog: false,
            darkMode: 'auto'
        };
        
        (function(d,t) {
            var g=d.createElement(t), s=d.getElementsByTagName(t)[0];
            g.src=BASE_URL+"/packs/js/sdk.js";
            g.defer = true; g.async = true;
            s.parentNode.insertBefore(g,s);

            g.onload = _initChatwoot;

        })(document,"script");

    }

    $ctrl.$onInit = () => {
        let idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        let idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        _getAreaMembros(idAreaMembros);
        _getUsuario(idUsuario);

        $scope.isDesktop = $rootScope.isDesktop;
    }

}]);